﻿import React from 'react';
import PropTypes from 'prop-types';

import { CookiesProvider } from 'react-cookie';
import { PersistGate } from 'redux-persist/lib/integration/react.js';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { persistor, store } from '../store.js';

import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary';
import ToastMessage from '../sites/viaGlobal/components/toastMessage';
import unregister from '../fetchInterceptor';
import AgGridKey from './ag-grid-key';
import initFontAwesome from '../sites/components/library/fontAwesome';

initFontAwesome();

import { ThemeProvider, createTheme } from '@mui/material/styles';
import { AppContext } from '../AppContext.jsx';
import RouteResolver from './RouteResolver.jsx';

const theme = createTheme();

const ContextType = {
  insertCss: PropTypes.func.isRequired,
  fetch: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
  query: PropTypes.object,
};

class App extends React.PureComponent {
  static propTypes = {
    context: PropTypes.shape(ContextType).isRequired,
    children: PropTypes.element.isRequired,
  };

  componentDidMount() {
    unregister();
  }

  render() {
    return (
      <ThemeProvider theme={theme}>
        <AppContext.Provider value={this.props.context}>
          <CookiesProvider>
            <PersistGate loading={null} persistor={persistor}>
              <Provider store={store}>
                <BrowserRouter>
                  <AgGridKey />
                  <ToastMessage renderContainer />
                  <ErrorBoundary>
                    <RouteResolver>{React.Children.only(this.props.children)}</RouteResolver>
                  </ErrorBoundary>
                </BrowserRouter>
              </Provider>
            </PersistGate>
          </CookiesProvider>
        </AppContext.Provider>
      </ThemeProvider>
    );
  }
}

export default App;
